<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูลสินค้า
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row
          ><v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Material No') }"
          >
            <label>{{ $t('Material No') }}</label>
            <input
              v-model="input.material_no"
              v-validate="'required'"
              :data-vv-as="$t('Material No')"
              class="form-control"
              type="text"
              name="Material No"
            />
            <span v-if="errors.has('Material No')" class="text-error">{{
              errors.first('Material No')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Marketing Group') }"
          >
            <label>{{ $t('Marketing Group') }}</label>
            <input
              v-model="input.marketing_group"
              v-validate="'required'"
              :data-vv-as="$t('Marketing Group')"
              class="form-control"
              type="text"
              name="Marketing Group"
            />
            <span v-if="errors.has('Marketing Group')" class="text-error">{{
              errors.first('Marketing Group')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Sub Marketing Group') }"
          >
            <label>{{ $t('Sub Marketing Group') }}</label>
            <input
              v-model="input.sub_marketing_group"
              v-validate="'required'"
              :data-vv-as="$t('Sub Marketing Group')"
              class="form-control"
              type="text"
              name="Sub Marketing Group"
            />
            <span v-if="errors.has('Sub Marketing Group')" class="text-error">{{
              errors.first('Sub Marketing Group')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Product Name EN') }"
          >
            <label>{{ $t('Product Name EN') }}</label>
            <input
              v-model="input.product_name_en"
              v-validate="'required'"
              :data-vv-as="$t('Product Name EN')"
              class="form-control"
              type="text"
              name="Product Name EN"
            />
            <span v-if="errors.has('Product Name EN')" class="text-error">{{
              errors.first('Product Name EN')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Product Name TH') }"
          >
            <label>{{ $t('Product Name TH') }}</label>
            <input
              v-model="input.product_name_th"
              v-validate="'required'"
              :data-vv-as="$t('Product Name TH')"
              class="form-control"
              type="text"
              name="Product Name TH"
            />
            <span v-if="errors.has('Product Name TH')" class="text-error">{{
              errors.first('Product Name TH')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Product Size') }"
          >
            <label>{{ $t('Product Size') }}</label>
            <input
              v-model="input.product_size"
              v-validate="'required'"
              :data-vv-as="$t('Product Size')"
              class="form-control"
              type="text"
              name="Product Size"
            />
            <span v-if="errors.has('Product Size')" class="text-error">{{
              errors.first('Product Size')
            }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('Score') }">
            <label>Score</label>
            <input
              v-model="input.score"
              v-validate="'required'"
              data-vv-as="Score"
              class="form-control"
              type="text"
              min="0"
              max="200000"
              name="Score"
              @keypress="keyIsNumber"
            />
            <span v-if="errors.has('Score')" class="text-error">{{ errors.first('Score') }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="$emit('close')">cancel</v-btn>
          <v-btn :loading="saveloading" depressed color="primary" @click="savedata">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        material_no: '',
        marketing_group: '',
        sub_marketing_group: '',
        product_name_th: '',
        product_name_en: '',
        product_size: '',
        score: null
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = { ...this.editdata }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createData()
        } else {
          this.editProduct()
        }
      }
    },
    async editProduct() {
      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        ...this.input,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.saveloading = true

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.putProduct(data)
          this.$emit('onsave')
        } catch (error) {
          console.error(error)
        } finally {
          this.saveloading = false
        }
      } else {
        api.updateProductToaecoupon(data, (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            this.$emit('onsave')
          }
        })
      }
    },
    async createData() {
      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        ...this.input,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.saveloading = true

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.postProduct(data)
          this.$emit('onsave')
        } catch (error) {
          console.error(error)
        } finally {
          this.saveloading = false
        }
      } else {
        api.insertProductToaecoupon(data, (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            this.$emit('onsave')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ProductEdit.vue